module.exports = __webpack_public_path__ + "static/media/test.js.33e7edec.snap";


//////////////////
// WEBPACK FOOTER
// ./src/pages/contact/__test__/__snapshots__/test.js.snap
// module id = 1026
// module chunks = 0